// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3lvVn","image":"styles-module--image--OePYX","title":"styles-module--title--MY2eo","description":"styles-module--description--20Rqo"};